import { SvgIcon, type SvgIconProps } from '@mui/material';

function SetLogo(props: Readonly<SvgIconProps>) {
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 108 40' fill='none'>
        <path
          fill='#231F20'
          d='M85.549 6.555v4.341h7.965v22.608h6.049V10.896h7.935V6.555h-21.95ZM48.839 14.1c0-2.964 2.694-3.862 5.06-3.862 2.994 0 5.809.928 7.426 1.976V8.052c-1.677-1.288-4.731-1.947-7.546-1.947-5.78 0-10.93 1.977-10.93 8.415 0 9.641 14.284 6.018 14.284 11.528 0 2.964-2.905 3.623-5.6 3.623-3.024 0-5.959-.809-8.474-2.216v4.312c1.677 1.138 4.552 2.186 8.235 2.186 4.132 0 11.917-1.467 11.917-8.444 0-9.882-14.373-6.199-14.373-11.409Zm22.816 15.122v-7.456h6.828c1.137 0 2.066-.719 2.066-1.707v-2.246h-8.894v-6.976h11.768V6.554H65.577v26.949h18.026v-4.282H71.655Z'
        />
        <path
          fill='#fff'
          d='M.008 19.994C.008 8.954 8.957.005 19.996.005c11.04 0 19.989 8.95 19.989 19.989 0 11.04-8.95 19.988-19.989 19.988-11.04 0-19.988-8.949-19.988-19.988Z'
        />
        <path
          fill='#231F20'
          d='M19.992 39.03c10.239 0 18.589-8.084 19.016-18.217h-1.674c-.832 0-1.302.479-1.493 1.053a7.77 7.77 0 0 1-14.607 1.353c-.875-1.682-2.615-2.406-4.255-2.406H.977C1.404 30.946 9.754 39.03 19.992 39.03Z'
        />
        <path
          fill='#FCB033'
          d='M19.992.964C9.754.964 1.404 9.048.977 19.18H2.65c.832 0 1.301-.479 1.492-1.053a7.769 7.769 0 0 1 14.608-1.353c.875 1.682 2.615 2.406 4.255 2.406h16.002C38.581 9.048 30.231.964 19.992.964Z'
        />
      </svg>
    </SvgIcon>
  );
}

export default SetLogo;
export { SetLogo };
